"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const faqs = [{
  question: "How do I start using OceanClaw?",
  answer: "Immediately after checkout, you'll receive an automated onboarding message via iMessage or Slack. There are no apps to download or APIs to configure—simply reply to the message to start interacting with the AI.",
  linkText: "View Onboarding Guide",
  linkUrl: "/HomePage"
}, {
  question: "Is my data private and secure?",
  answer: "We prioritize your privacy with enterprise-grade encryption. Your conversations are private, and we never use your personal or business data to train public models. Your secrets stay within your private thread.",
  linkText: "Read Privacy Details",
  linkUrl: "#"
}, {
  question: "Which AI models does OceanClaw use?",
  answer: "We orchestrate the latest frontier models, including GPT-4o and Claude 3.5 Sonnet. Our system automatically selects the most capable model for your specific request to ensure premium results every time.",
  linkText: "Explore Capabilities",
  linkUrl: "#"
}, {
  question: "Can I use OceanClaw for my business team?",
  answer: "Yes. While we focus on consumer simplicity, we also support custom enterprise deployments, private on-premise installations, and tailored configurations for organizations needing specialized workflows.",
  linkText: "Enterprise Solutions",
  linkUrl: "#"
}, {
  question: "Do I need to learn how to write prompts?",
  answer: "Not at all. OceanClaw is designed for natural conversation. You can speak to it just like you would a colleague or friend. Our intelligent orchestration handles the complexity behind the scenes.",
  linkText: "See Use Cases",
  linkUrl: "/HomePage"
}];
export default function CommonInquiries() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="29683" id="clarifications" className="dark bg-background py-24 sm:py-32">
      <div ref={ref} className={cn("container mx-auto px-6 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
        <div className="mx-auto max-w-4xl">
          <div className="mb-12 text-center">
            <h2 className="text-3xl font-default font-bold tracking-tight text-foreground sm:text-4xl">
              Clarifications
            </h2>
            <p className="mt-4 text-lg text-muted-foreground font-default">
              Everything you need to know about unlocking full-scale AI capability
              in under a minute with OceanClaw.
            </p>
          </div>

          <Accordion type="single" collapsible className="w-full space-y-4">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} className="border-border bg-card/40 rounded-xl border px-6 shadow-sm transition-all hover:bg-card/60 data-[state=open]:border-primary data-[state=open]:shadow-[0_0_20px_rgba(59,130,246,0.15)]" data-index={i}>
                <AccordionTrigger className="text-lg font-default font-semibold text-foreground hover:no-underline hover:text-primary transition-colors">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-base text-muted-foreground font-default">
                  <div className="flex flex-col gap-3 pb-2">
                    <p>{faq.answer}</p>
                    {faq.linkUrl && <Link to={faq.linkUrl} className="text-primary hover:text-primary/80 inline-flex w-fit items-center font-default font-medium transition-colors">
                        {faq.linkText} &rarr;
                      </Link>}
                  </div>
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}